"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInvitationsEndpoints = createInvitationsEndpoints;
/**
 * Etkinlik davetleri (`invite_only` ve `approval`).
 */
function createInvitationsEndpoints(client) {
    return {
        invitations: {
            send: (eventId, input) => client.call('/events/{eventId}/invitations', 'post', { path: { eventId }, body: input }),
            list: (eventId, query) => client.call('/events/{eventId}/invitations', 'get', {
                path: { eventId },
                query: query,
            }),
            resend: (eventId, invitationId) => client.call('/events/{eventId}/invitations/{invitationId}/resend', 'post', {
                path: { eventId, invitationId },
            }),
            revoke: (eventId, invitationId) => client.call('/events/{eventId}/invitations/{invitationId}/revoke', 'post', {
                path: { eventId, invitationId },
            }),
            /** Jeton BAŞLIKTA gider, adreste değil: adres her kayda düşer (sıra 132). */
            lookup: (token) => client.call('/invitations/lookup', 'get', { header: { 'x-invitation-token': token } }),
            /** Ekran G3: kullanılamaz davette bile etkinlik künyesi. */
            brief: (token) => client.call('/invitations/brief', 'get', { header: { 'x-invitation-token': token } }),
            requestNew: (input) => client.call('/invitations/request-new', 'post', { body: input }),
            accept: (input) => client.call('/invitations/accept', 'post', { body: input }),
            decline: (input) => client.call('/invitations/decline', 'post', { body: input }),
            /**
             * B-15: jetonsuz karar — etkinlik sayfası ve bildirim yolu. Davet oturumun
             * e-postasıyla eşlenir; gövde jeton ya da davet kimliği taşımaz.
             */
            acceptMine: (eventId, input) => client.call('/events/{eventId}/invitation/accept', 'post', {
                path: { eventId },
                body: input,
            }),
            declineMine: (eventId) => client.call('/events/{eventId}/invitation/decline', 'post', { path: { eventId } }),
            /** QA B-15: karar bloğu görüldü, davet "açıldı" olur. Yanıt her durumda 204. */
            openMine: (eventId) => client.call('/events/{eventId}/invitation/open', 'post', { path: { eventId } }),
        },
    };
}
//# sourceMappingURL=invitations.js.map